import styled from '@emotion/styled'

import { tokens } from '@news-mono/design-tokens'
import { breakpoint, calcRem, metrics, fonts } from '../../../__styling'

export const PlaceholderContainer = styled.div<{
    type: 'homepage' | 'editions'
}>(({ type }) => ({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    alignSelf: 'center',
    justifyContent: 'center',
    overflow: 'hidden',
    gap: 0,
    borderRadius: calcRem(metrics.thenightly.margins.sm2l),
    border: '1px solid',
    borderColor: tokens.thenightly.colors.palette.neutral[20],
    width: '95%',
    padding: calcRem(24, 0),
    paddingBottom: 0,
    margin: 'auto',

    [breakpoint('sm')]: {
        flexDirection: 'row',
        gap: calcRem(16),
        padding: calcRem(0, metrics.thenightly.margins.xl),
    },

    [breakpoint('md')]: {
        width: type === 'editions' ? '75%' : '95%',
    },
}))

export const StyledColumn = styled.div({
    display: 'flex',
    flexDirection: 'column',
    padding: 0,
    margin: 0,
})

export const StyledTitle = styled.h2({
    fontFamily: fonts.thenightly.heading,
    fontWeight: 600,
    color: tokens.thenightly.colors.text.heading,
    fontSize: calcRem(40),
    letterSpacing: calcRem(-1.2),
    margin: 0,

    [breakpoint('sm')]: {
        fontSize: calcRem(51),
        lineHeight: '110%',
        letterSpacing: calcRem(-1.53),
    },
})

export const StyledText = styled.p({
    fontFamily: fonts.thenightly.heading,
    fontWeight: 400,
    color: tokens.thenightly.colors.palette.neutral[70],
    fontSize: calcRem(16),
    lineHeight: calcRem(24),
})

export const StyledImageContainer = styled.img({
    width: calcRem(283.52),
})
